<div class="modal-header">
    <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" (click)="cancel()">
        <span aria-hidden="true">&times;</span>
    </button>
    <h4 class="modal-title" id="labelButtons">{{modalTitle}}</h4>
</div>
<div class="modal-body">
    <validation-results [validationResults]="validationResults" *ngIf="showValidationComponent"></validation-results>
    <form [formGroup]="addArtifactsForm" autocomplete="off">
        <fieldset>
            <div class="row">
                <div class="col-sm-9 col-md-5 mvd_form-group">
                    <label class="required" title="* Required" for="documentTypeId">DocumentType</label>
                    <p-dropdown [options]="documentTypes" formControlName="documentTypeId" placeholder="Select"></p-dropdown>
                    <control-validation-messages control="documentTypeId"></control-validation-messages>
                </div>
            </div>
        </fieldset>
    </form>
</div>

<div class="modal-footer">
    <div class="btn--group">
        <button class="btn--default" data-bs-toggle="tooltip" data-bs-dismiss="modal" (click)="cancel()">Cancel</button>
        <mvm-spinner-btn [isDisabled]="!addArtifactsForm.valid" btnType="button" [isLoading]="isProcessing" btnText="Save" (clicked)="reCreateArtifacts()"></mvm-spinner-btn>
    </div>
</div>